<div class="help-screen">
  <div class="help">
    <kp-help>
      <kui-modal
        *ngIf="isUnsupported"
        class="hidden-print"
        type="info"
        [isOpen]="showSupportedBrowsersModal"
        (isOpenChange)="toggleUnsupportedBrowsersModal()"
        (modalCloseMethod)="toggleUnsupportedBrowsersModal()"
        describedById="unsupportedBrowserInfo">
        <div class="unsupported-browser-modal">
          <svg-icon src="/assets/icons/alert-circle.svg" class="unsupported-icon"></svg-icon>
          <h3 class="unsupported-header">Your browser is unsupported</h3>
          <p id="unsupportedBrowserInfo" class="unsupported-browser-text">
            Looks like you are using an older, unsupported web browser. For your security and the best experience, we
            recommend using one of these browsers:
          </p>
          <div class="browser-container">
            <div *ngFor="let browser of shownBrowserList">
              <a class="browser-link" href="{{ browser.url }}" target="_blank">
                <img class="browser-image" src="{{ browser.icon }}" alt="{{ browser.displayName }} icon" />
                <span class="browser-name">{{ browser.displayName }}</span>
              </a>
            </div>
          </div>
          <p class="unsupported-browser-text">
            If you need additional help, get in touch with technical support anytime by email.
          </p>
          <a
            href="mailto:support@kumanu.com?Subject={{ productName }}%20Support%20Request%20-%20Unsupported%20Browser"
            class="button button-pill button-secondary-reverse button-continue"
            type="button">
            support@kumanu.com
          </a>
        </div>
      </kui-modal>
    </kp-help>
    <!-- Adding comment to remove extra space that Prettier adds -->
    <!-- prettier-ignore -->
    <p class="unsupported-browser-info" *ngIf="isUnsupported">
      Looks like you are using an older, unsupported web browser.
      <br />
      View our <button class="unsupported-browser-toggle" (click)="toggleUnsupportedBrowsersModal(true, $event)">
        recommended browsers
      </button>.
    </p>
  </div>
</div>
